import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import {
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";


class Contact extends Component {
  render() {
    return (
       <div>
        <div className="contact_intro">
        </div>
        <div className="banner_callout light">
          <div className="banner_callout_text">
          We are passionate about helping people live healthier and more fulfilling lives. Contact us to learn more about how we can help you or partner with your organization and begin the conversation of what possibilities and opportunities we can create together for your future.
      </div>
      </div>
    <div className="banner contact_panel">
    <div className="gradient-h">
    <div className="container_space contact_content" >
          
          <div className="content_text">
          <div className="content_text_title">Connect With Us</div>
          Contact us to request more information or speak with one of our representatives and learn about how we can provide benefits to your life.
          <div className="contact_info">
              <div>
                Phone: 1-855-WMGRNOW
              </div>
              <div>
                Email: info@wellnessmatrixgroup.com
              </div>
              <div>
              </div>
            </div> 
          </div>
          </div>
    </div>
        </div>

        
        <div className="container_space" >
          <div className="">
           </div>
        </div>
      
        <div className="banner_callout gray">
          <div className="banner_callout_text">
          If you have any suggestions or requests, we are always open to feedback and would love to hear your comments and ideas.  Don’t hesitate to reach out and connect with one of our representatives to explore how we can improve or better support your goals and life mission.
        </div>
      </div>
       
    </div>
    );
  }
}

export default Contact;